import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { LoginGuard } from './core/guard/login.guard';
import { TokenGuard } from './core/guard/token.guard';
import { TwoFactorAuthGuard } from './core/guard/twoFactorAuth.guard';

const routes: Routes = [
  // {
  //   path: 'app',
  //   loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  //   canActivate: [AuthenticationGuard, StagingGuard],
  // },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [TokenGuard, LoginGuard],
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
    canActivate: [TokenGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
    canActivate: [TokenGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
    canActivate: [TokenGuard],
  },
  {
    path: 'verify',
    loadChildren: () => import('./verification/verification.module').then((m) => m.VerificationModule),
    canActivate: [TokenGuard],
  },
  {
    path: 'two-factor-auth',
    loadChildren: () => import('./two-factor-auth/two-factor-auth.module').then((m) => m.TwoFactorAuthModule),
    canActivate: [TokenGuard, TwoFactorAuthGuard],
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
    canActivate: [TokenGuard, AuthenticationGuard],
  },
  // {
  //   path: 'pricing',
  //   loadChildren: () => import('./pricing/pricing-page.module').then((m) => m.PricingPageModule),
  //   canActivate: [TokenGuard]
  // },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
